import Reveal from "reveal.js";
import { removeAllHighlights } from "./removeAllHighlights";
import { resetMap } from "./resetMap";
import { highlightActiveRoomsOnMap } from "./highlightActiveRoomsOnMap";
import { getActiveIndex, setActiveIndex } from "./activeIndex";
import { addToLoopCount,
// getLoopCount
 } from "./loopCount";
import { getRoomsRendered } from "./roomsRendered";
import { roomInteractions } from "./roomInteraction";
import { rememberMapInterval } from "./mapInterval";
export function autoLoopMapHighlights() {
    resetMap();
    let activeIndex = getActiveIndex();
    document.addEventListener("click", roomInteractions);
    rememberMapInterval(window.setInterval(() => {
        removeAllHighlights();
        if (activeIndex >= getRoomsRendered().length - 1) {
            activeIndex = 0;
            if (addToLoopCount() >= 1 && Reveal.getTotalSlides() > 1) {
                // if loop count is 2 or more and there are more slides than reset and change slide
                // we're done and can go onto the next slide.
                // go to next slide and reset
                Reveal.next();
                // resets in Reveal.on("slidechanged"...
            }
        }
        else {
            activeIndex++;
        }
        setActiveIndex(activeIndex);
        highlightActiveRoomsOnMap(activeIndex);
    }, 1000 * 10)); // 10 seconds
}
